import React from "react";
import StaticResourceText from '../Format/static-resource-text';
import ThumbnailView from "./ThumbnailView";
const GOC_Parrallex_container = ({ resources, resourceKey, Domaincons, solutionIcons, OfferIcons }) => {
    return (

        <div className="parallax-container">
            <section className="container" id="presentation_services">
                <div className="list-container">
                    {!!resourceKey && <StaticResourceText resources={resources} reskey={resourceKey}></StaticResourceText>}
               
                {!!Domaincons.length && (
                    <ThumbnailView
                        icons={Domaincons}
                        resources={resources}
                        resourceKey={"IMMERSIVE_INTERACTIVE_DOMAINS"}
                        background={{ backgroundColor: "#fff" }}
                    
                    ></ThumbnailView>
                )}
                {!!solutionIcons.length && (
                    <ThumbnailView
                        icons={solutionIcons}
                        resources={resources}
                        resourceKey={"IMMERSIVE_INTERACTIVE_SOLUTION"}
                        background={{ backgroundColor: "#fff" }}
                    ></ThumbnailView>
                )}
                {!!OfferIcons.length && (
                    <ThumbnailView
                        icons={OfferIcons}
                        resources={resources}
                        resourceKey={"IMMERSIVE_INTERACTIVE_OFER"}
                        background={{ backgroundColor: "#fff" }}
                    ></ThumbnailView>
                )}
                 </div>
            </section>
        </div>
    );
};
export default GOC_Parrallex_container;

